import { computed, shallowReactive } from 'vue';
import type { VPConfirmationDialogOutcome } from '../components/VPConfirmationDialog.vue';

export type ConfirmationDialogOptions = {
  title: string;
  message?: string;
  confirmLabel: string;
  cancelLabel?: string;
  checkboxLabel?: string;
  action?: (outcome: VPConfirmationDialogOutcome) => unknown;
};

type ConfirmationDialogRequest = ConfirmationDialogOptions & {
  id: number;
  resolve: (outcome: VPConfirmationDialogOutcome) => void;
  reject: (error: unknown) => void;
};

// Module-level so stores and plain helpers can ask too; one `VPConfirmationDialogHost` shows the head.
const queue = shallowReactive<ConfirmationDialogRequest[]>([]);
let nextId = 0;

/** Opens the confirmation dialog; resolves with the answer, or rejects with a failed `action`'s error. */
export const openConfirmationDialog = (options: ConfirmationDialogOptions) =>
  new Promise<VPConfirmationDialogOutcome>((resolve, reject) => {
    queue.push({ ...options, id: nextId++, resolve, reject });
  });

export const useConfirmationDialogHost = () => ({
  current: computed(() => queue[0]),
  settle: (id: number, outcome: VPConfirmationDialogOutcome, failure?: { error: unknown }) => {
    if (queue[0]?.id !== id) {
      return;
    }

    const request = queue.shift()!;

    if (failure) {
      request.reject(failure.error);
    } else {
      request.resolve(outcome);
    }
  },
});
